angular.module('impactx.dashboard').controller('AddDashboardGridCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    AddDashboardGridCtrl]);

function AddDashboardGridCtrl($scope, $mdDialog, TranslationService) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.confirmLabel = TranslationService.get("accept");
    $scope.errorList = [];

    var self = this;

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        $mdDialog.hide({width: selectedWidth.value, height: selectedHeight.value});
    };

    var widthOptions = [];
    for (var i = 1; i < 8; i++) {
        widthOptions.push({value: i});
    }
    var selectedWidth = widthOptions[4];
    widthOptions[4].selected = true;

    var heightOptions = [];
    for (var j = 1; j < 8; j++) {
        heightOptions.push({value: j});
    }
    var selectedHeight = heightOptions[4];
    heightOptions[4].selected = true;

    this.getNumbersForWidthOption = function() {
        return widthOptions;
    };

    this.getNumbersForHeightOption = function() {
        return heightOptions;
    };

    this.selectWidth = function (selectedOption) {
        for (var i = 0; i < widthOptions.length; i++) {
            widthOptions[i].selected = false;
        }
        selectedOption.selected = true;
        selectedWidth = selectedOption;
    };

    this.selectHeight = function (selectedOption) {
        for (var i = 0; i < heightOptions.length; i++) {
            heightOptions[i].selected = false;
        }
        selectedOption.selected = true;
        selectedHeight = selectedOption;
    };
}